import script from "./users-list.vue?vue&type=script&setup=true&lang=js"
export * from "./users-list.vue?vue&type=script&setup=true&lang=js"

import "./users-list.vue?vue&type=style&index=0&id=331f0e42&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331f0e42"]])

export default __exports__